import { isWeb, tva } from "@gluestack-ui/utils/nativewind-utils";
const baseStyle = isWeb ? "flex flex-col relative z-0" : "";

export const cardStyle = tva({
  base: baseStyle,
  variants: {
    size: {
      xs: "p-1 rounded-lg",
      sm: "p-3 rounded-lg",
      md: "p-4 rounded-lg",
      lg: "p-6 rounded-xl",
      xl: "p-8 rounded-3xl",
    },
    variant: {
      elevated: "bg-background-0",
      outline: "border border-outline-100",
      ghost: "rounded-none",
      filled: "bg-background-50 border border-outline-50",
    },
  },
});
